import React from 'react';
import { ISigSyncNotaryDetailsData } from '../../../../../types/signingAppointment/ISigSyncNotaryDetailsData';
import { faCar, faStamp, faFileSignature, faWarning } from '@fortawesome/pro-regular-svg-icons';
import { TextButtonTW } from '../../../../../tailwindComponents/buttonTW/TextButtonTW';
import { formatPhoneNumber } from '../../../../../utilities/shared/formatPhoneNumber';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BodyTextTW, BoldBodyTextTW } from '../../../../../tailwindComponents/bodyText/BodyTextTW';
import { Show } from '../../../../shared/Show';
import { getDisplayVehicleInfo } from '../../../../../types/signingAppointment/INotaryDetailsData';

export const SigSyncNotaryDetails = ({ notary }: { notary: ISigSyncNotaryDetailsData }) => {
  return (
    <div className={'flex flex-col gap-2'}>
      <section className={'flex justify-start gap-3'}>
        <div>
          <FontAwesomeIcon icon={faStamp} />
        </div>
        <div>
          <BodyTextTW>Assigned Notary</BodyTextTW>
        </div>
      </section>
      <section className={'flex gap-6'}>
        <div></div>
        <div className={'flex w-full flex-row gap-5'}>
          <section className={'flex w-3/5 flex-row'}>
            <Show when={!!notary.pictureUrl}>
              <img
                alt={'notary'}
                data-test-id={'notary-picture'}
                className={'mt-0.5 h-20 w-20 rounded-md object-fill'}
                src={notary.pictureUrl}
              />
            </Show>
            <div className="ml-2 flex flex-col">
              <section className="flex flex-row gap-5">
                <BoldBodyTextTW>{`${notary?.firstName || ''} ${notary?.lastName || ''}`}</BoldBodyTextTW>
              </section>
              <section className="flex flex-col">
                <TextButtonTW className="!text-left">{notary?.email || ''}</TextButtonTW>
                <TextButtonTW className="!text-left">{formatPhoneNumber(notary?.phoneNumber || '')}</TextButtonTW>
              </section>
            </div>
          </section>
          <section className={'flex w-2/5 flex-col'}>
            <Show when={!!notary?.signatureSyncNotaryDetails?.signingsAssigned}>
              <div className={'flex flex-row gap-1'}>
                <div>
                  <FontAwesomeIcon icon={faFileSignature} />
                </div>
                <BodyTextTW>{`${notary?.signatureSyncNotaryDetails?.signingsAssigned} signings completed`}</BodyTextTW>
              </div>
            </Show>
            <Show when={!!notary?.signatureSyncNotaryDetails?.errorRate}>
              <div className={'flex flex-row gap-1'}>
                <div>
                  <FontAwesomeIcon icon={faWarning} />
                </div>
                <BodyTextTW>{`${notary?.signatureSyncNotaryDetails?.errorRate}% error rate`}</BodyTextTW>
              </div>
            </Show>
            <Show when={!!(notary.vehicleMake || notary.vehicleModel || notary.vehicleLicensePlate)}>
              <div className={'flex flex-row gap-1'}>
                <div>
                  <FontAwesomeIcon icon={faCar} />
                </div>
                <BodyTextTW>{getDisplayVehicleInfo(notary)}</BodyTextTW>
              </div>
            </Show>
          </section>
        </div>
      </section>
    </div>
  );
};
